import React from "react";
import { Card, List, Typography, Tag } from "antd";
import { UserOutlined } from "@ant-design/icons";

const { Text } = Typography;

export default function HistoryCard({ issue, user }: any) {
  const activity = Array.isArray(issue.activity) ? issue.activity : [];

  const getUserNameById = (userId: string | undefined) => {
    if (!userId) return "Unknown User";

    const foundUser = user[userId];

    console.log("🚀 ~ getUserNameById ~ userId:", userId);
    console.log(
      "🚀 ~ getUserNameById ~ foundUser:",
      foundUser ? foundUser.name : "Not Found"
    );

    return foundUser?.name || userId || "Unknown User";
  };

  return (
    <Card title="Updates">
      <List
        itemLayout="vertical"
        size="small"
        dataSource={activity}
        renderItem={(item: any) => (
          <List.Item key={item.updated_at} style={{ marginBottom: 16 }}>
            <Text strong>
              {new Date(item.updated_at).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })}{" "}
              -{" "}
              {new Date(item.updated_at).toLocaleTimeString("en-US", {
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: true,
              })}
            </Text>

            <div style={{ marginTop: 8 }}>
              <Text>
                {item.event.charAt(0).toUpperCase() + item.event.slice(1)}:{" "}
                <Tag color="red">{getUserNameById(item.changes.from)}</Tag> →{" "}
                <Tag color="green">{getUserNameById(item.changes.to)}</Tag>
              </Text>
            </div>

            <div style={{ marginTop: 8 }}>
              <Text type="secondary">
                Updated by: <UserOutlined style={{ marginRight: 4 }} />
                {getUserNameById(item.updated_by)}{" "}
              </Text>
            </div>
          </List.Item>
        )}
      />
    </Card>
  );
}
